export default __webpack_public_path__ + "static/media/hht2_ep07_book_wp_01.ba67d42d.jpg";